export const state = () => ({
  transferResponsibleDate: '',
  transferEndDate: '',
})

export const mutations = {
  setTransferApplyDate: (state, value) =>
    (state.transferResponsibleDate = value),
  setTransferEndDate: (state, value) => (state.transferEndDate = value),
}
